export class BannerRefreshPolicyCfgJs {
    data: Record<string, number>;

    constructor(data: Record<string, number>) {
        this.data = data;
    }

    getTimeout(bannerName: string): number {
        const key = `timeout.${bannerName}`;
        const specific = this.data.hasOwnProperty(key) ? this.data[key] : null;
        return specific !== null ? specific : this.data["timeout.default"];
    }

    getTransition(bannerName: string): boolean {
        const key = `transition.${bannerName}`;
        const specific = this.data.hasOwnProperty(key) ? this.data[key] : null;
        return specific !== null ? !!specific : !!this.data["transition.default"];
    }
}